var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('transition',{attrs:{"css":false},on:{"before-enter":_vm.beforeEnter,"enter":_vm.enter,"leave":_vm.leave}},[(_vm.show)?_c('div',{staticClass:"maintenance-banner"},[_c('h2',[_c('i',{staticClass:"material-icons"},[_vm._v("warning")]),_vm._v(" "+_vm._s(_vm.statusText))]),_c('p',[_vm._v(" "+_vm._s(_vm.message)+" ")])]):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }